import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: paginacaoListagem(['seq'], 25, 'ASC'),
	idAdesao: null,
	justificativa: null,
	itensSelecionados: [],
	numeroCasasDecimaisQtde: null,
	numeroCasasDecimaisValores: null,
	informacoesAdesao: {},
	isPossuiItensEmElaboracao: false,
	isPossuiItensEmRascunho: false,
	atualizaListagem: 0,
	revisao: {},
}
